import { RootState } from '../reducers';

export const selectIsOnline = (userId?: number) => ({ users }: RootState) =>
  userId ? users.onlineUsersIds.includes(userId) : undefined;
